export default {
  homePara:
    "Language localisation is the process of adapting a product's translation to a specific country or region. It is the second phase of a larger process of product translation and cultural adaptation to account for differences in distinct markets, a process known as internationalisation and localisation.",
  aboutPara:
    "This tutorial is targetted to make localization simple. Though there are a lot of tutorials available on the internet. But, this one will teach you the concept in a simple manner. You can directly use this code for your software. I have used 'Rreact' hooks which is software industry standard now. You can follow my blog to get more UI related articles which will make you a better 'UI' developer. {0}",
  changeLanguage: "ভাষা নির্বাচন করুন",
  Libas_Tailor: "লিবাস টেইলার্স",
  name: "নাম",
  search_by: "অনুসন্ধান",
  orderNumber: "অর্ডার নম্বর",
  item: "বস্তু",
  trackingNumber: "ট্র্যাকিং নম্বর",
  OrderDate: "অর্ডারের তারিখ",
  Qty: "পরিমাণ",
  dynamicValue: "Dynamic Value- {randomNumber} {date}",
  Customer: "গ্রাহক",
  cloth_Items: "কাপড়ের আইটেম",
  //** Button */
  product_item: "পণ্য আইটেম",
  settings_product_measurement: "সেটিংস > পণ্য পরিমাপ",
  sms_balance: "এসএমএস ব্যালেন্স",
  //** Home Page */
  add_new_order: "নতুন অর্ডার যোগ করুন",
  add_new_customer: "নতুন গ্রাহক যোগ করুন",
  add_customer_measurement: "গ্রাহকের পরিমাপ যোগ করুন",
  add_customer_order: "কাস্টমার অর্ডার যোগ করুন",
  edit_customer: "গ্রাহক সম্পাদনা করুন",
  view_measurement: "পরিমাপ দেখুন",
  view_order: "অর্ডার দেখুন",
  search_customers: "গ্রাহকদের অনুসন্ধান করুন",
  search_trackingNo: "ট্ট্র্যাকিং নম্বর অনুসন্ধান করুন",
  search_orders: "ORDER অনুসন্ধান করুন",

  si: "সিরিয়াল",
  phone: "ফোন",
  order: "অর্ডার",
  customer_name: "ক্রেতার নাম",
  order_date: "অর্ডারের তারিখ",
  order_number: "অর্ডার নম্বর",
  delivery_date: "ডেলিভারি তারিখ",
  copy_right:
    "কপিরাইট © ডিজাইন এবং ডেভেলপ করেছে '(01720944188) => jafarulla15@gmail.com'",

  qty: "পরিমাণ",
  note: "বিঃদ্রঃ",
  Loading: "লোড হচ্ছে",

  //** Button text */
  Remove: "অপসারণ করুন",
  Save: "সংরক্ষণ করুন",
  status: "অবস্থা",
  statusInfo: "অবস্থা তথ্য",
  statusDetail: "অবস্থা বিস্তারিত",
  responsible: "দায়গ্রস্ত",
  statusDate: "অবস্থা তারিখ",

  assignClothToTailor: "দর্জিকে কাপড় বরাদ্দ করুন",
  receiveReadyCloth: "প্রস্তুত কাপড় গ্রহণ করুন",
  deliverClothToCustomer: "গ্রাহককে কাপড় সরবরাহ করুন",

  //** Print Measurement */
  Customer_Name: "কাস্টমার নাম",
  Tracking_NO: "ট্র্যাকিং নং",
  QTY: "সংখ্যা",
  NOTE: "নোট",
  Phone: "ফোন",
  Order_No: "অর্ডার নং",

  //**** */
  Customer_Information: "কাস্টমার তথ্য",


};
